enum PerformanceTab {
  Throughput = 'throughput',
  Focus = 'focus',
  FlowByPhase = 'flow_by_phase',
  Targets = 'targets',
  Milestones = 'milestones',
  Cost = 'cost',
  RelatedTasks = 'related_tasks',
}

enum ThroughputMode {
  InitiativeProgress = 'initiative_progress',
  ContributingEpics = 'contributing_epics',
  ContributingTeams = 'contributing_teams',
  ContributingInitiatives = 'contributing_initiatives',
  ContributingOutcomes = 'contributing_outcomes',
}

enum FocusMode {
  ContributingTeams = 'contributing_teams',
  ContributingBoards = 'contributing_boards',
}

enum SortDirection {
  Asc = 'asc',
  Desc = 'desc',
}

enum EpicSortOption {
  ID = 'ID',
  Name = 'Name',
  Tasks = 'Tasks',
}

export { EpicSortOption, FocusMode, PerformanceTab, SortDirection, ThroughputMode };
